// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { default as SessionTracker } from './SessionTracker';
export default SessionTracker;
//# sourceMappingURL=index.js.map